<template>
  <div>
    <div class="contents contents--pt">
      <section class="Form _min-h">
        <div class="inner">
          <div class="Form--pt">
            <img class="Form__thank_img" src="assets/img/thank.png" alt="ok">
            <p class="Form__tx _ft-cnt _txt-lg">
              送信完了
            </p>
            <p class="Form__tx _ft-cnt _txt-sm">
              ありがとうございました
            </p>
            <p class="Form__tx _ft-cnt _cl-01 _font-lg">
              後ほど、ご自身の現在のストレス値とオススメのクラスがメールで送信されます。
            </p>
            <router-link
              to="/"
              class="Btn__blue Form__btn--mt_md Form__btn--mt_sp_sm"
            >
              HOMEに戻る
            </router-link>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MindfulSurveyThanks'
}
</script>
